/* eslint-disable arrow-body-style */

import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormArray,
  Validators,
  FormControl,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as validatorUtility from '@cigna/cigna-for-brokers/shared/util';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'cigna-cfb-ifp-contractor-box',
  templateUrl: './ifp-contractor-box.component.html',
  styleUrls: ['./ifp-contractor-box.component.scss'],
})
export class IfpContractorBoxComponent implements OnInit {
  ifpForm: FormGroup;
  countries: string[] = [];
  @Output() closed = new EventEmitter();
  @Output() continueClicked = new EventEmitter();
  @Output() cancelClicked = new EventEmitter();
  @Output() mailAddressRequested = new EventEmitter<boolean>();
  respClass = 'address-responsive';
  selectedState = this._translate.instant('global.select');
  getFormData$ = this.appstateFacade.getOnBoardingFormData$;
  _ngSubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private _translate: TranslateService,
    private appstateFacade: AppstateFacade,
  ) {
    const countriesJson = this._translate.instant(
      'onboarding.addressInfo.stateList',
    ) as string[];
    this.countries = [...countriesJson].sort();
  }

  ngOnInit() {
    this.ifpForm = new FormGroup({
      licensedInCt: new FormControl(''),
      state: new FormControl(''),
      residentStates: new FormControl('', [
        Validators.required,
        validatorUtility.selectRequiredValidator,
      ]),
    });

    this.getFormData$.pipe(takeUntil(this._ngSubscribe$)).subscribe((res) => {
      this.ifpForm.patchValue({
        licensedInCt: res.ifp.isLicensedCt,
        state: res.ifp.producerstate,
        residentStates: res.ifp.statesLicensed,
      });
    });
  }

  onContinue() {
    const ifpData = {
      isLicensedCt: this.ifpForm.get('licensedInCt')?.value ?? '',
      producerstate: this.ifpForm.get('state')?.value ?? '',
      statesLicensed: this.ifpForm.get('residentStates')?.value ?? '',
    };
    this.appstateFacade.saveIfpInfo(ifpData);
    this.appstateFacade.saveIfpContinueFlag(true);

    this.continueClicked.emit();
  }

  numberOnly($event: { which: number; keyCode: number }): boolean {
    return validatorUtility.numberOnly($event);
  }

  cancelForm() {
    this.closed.emit();
  }

  isLicensedInCt(isLicensedInCtArea: boolean) {}

  onCancelClicked() {
    this.cancelClicked.emit();
  }
}
